import { SortDirection as Sd, SortFn } from "../core/types/component";


export const handleToggleSortValues = <T>(options: {
  values: T[],
  setValues: React.Dispatch<React.SetStateAction<T[]>>,
  key: string,
  sortDirection: Sd | null,
  setSortDirection: (value: React.SetStateAction<Sd | null>) => void,
  unsetSortDirections: ((value: React.SetStateAction<Sd | null>) => void)[],
  updateValues?: (values: T[]) => void,
  // comparison function to determine greater/lesser
  sortFn?: SortFn }) => () =>
  {
    const sortFn = options.sortFn || ((a: number, b: number) => a - b);

    const sortedValues = [...options.values].sort((a, b) =>
      // @ts-ignore
      sortFn(a[options.key as keyof T], b[options.key as keyof T]) *
      (options.sortDirection === Sd.ascending ? -1 : 1));

    options.setValues(sortedValues);

    options.unsetSortDirections.forEach(u => u(null));

    options.sortDirection === Sd.ascending ?
      options.setSortDirection(Sd.descending) :
      options.setSortDirection(Sd.ascending);

    if(options.updateValues)
      options.updateValues(sortedValues);
  };



